import { SvgIcon, SvgIconProps } from "@mui/material";

export default function InfoIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h30v30H0z" />
        <circle cx="15" cy="15" r="11.25" fill="#697B8C" />
        <path
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.875"
          d="M15 10v5M15 20h.012"
        />
      </g>
    </SvgIcon>
  );
}
